__turbopack_context__.v({
  "calendar": "index-module-scss-module__o_gRCG__calendar",
});
